import type { SwitchCity } from '../model/types';

const PINNED_NAMES: readonly string[] = ['Москва', 'Санкт-Петербург'];

export interface CityGroup {
  letter: string;
  cities: SwitchCity[];
}

export interface GroupedCities {
  pinned: SwitchCity[];
  groups: CityGroup[];
}

export function groupCities(cities: SwitchCity[], query?: string): GroupedCities {
  const q = (query ?? '').trim().toLowerCase();
  const filtered = q === '' ? cities : cities.filter((c) => c.name.toLowerCase().includes(q));

  const pinned: SwitchCity[] = [];
  for (const name of PINNED_NAMES) {
    const city = filtered.find((c) => c.name === name);
    if (city) {
      pinned.push(city);
    }
  }

  const rest = filtered
    .filter((c) => !PINNED_NAMES.includes(c.name))
    .sort((a, b) => a.name.localeCompare(b.name, 'ru'));

  const groups: CityGroup[] = [];
  for (const city of rest) {
    const letter = (city.name[0] ?? '').toUpperCase();
    const group = groups.find((g) => g.letter === letter);
    if (group) {
      group.cities.push(city);
    } else {
      groups.push({ letter, cities: [city] });
    }
  }

  groups.sort((a, b) => {
    const aCyr = isCyrillic(a.letter);
    const bCyr = isCyrillic(b.letter);
    if (aCyr && bCyr) {
      return a.letter.localeCompare(b.letter, 'ru');
    }
    if (aCyr) {
      return -1;
    }
    if (bCyr) {
      return 1;
    }
    return 0;
  });

  return { pinned, groups };
}

function isCyrillic(letter: string): boolean {
  return /^[А-ЯЁ]/.test(letter);
}
